export const cols = [{
	prop: 'orderstatus',
	label: '订单状态',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerName',
	label: '客户名称',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customerCode',
	label: '客户编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customercategoryname',
	label: '客户类别',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'realMoney',
	label: '订货金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sendMoney',
	label: '实发金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'receiveMoney',
	label: '实收金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'diffMoney',
	label: '差发金额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyDiffMoney',
	label: '差收金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundMoney',
	label: '实退金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realReceiveMoney',
	label: '净收金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'offLineMoney',
	label: '线下支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'wxLineMoney',
	label: '微信支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'tenpayMoney',
	label: '微企付支付金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'preMoney',
	label: '预付货款金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'liquidateMoney',
	label: '已勾销金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'ownMoney',
	label: '尚欠金额',
	width: '150',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyername',
	label: '收货人',
	width: '150',
	// ischoose: true,
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'btel',
	label: '联系电话',
	width: '150',
	// ischoose: true,
	headerAlign: 'center',
	align: 'center'
}, {
	prop: 'buyeraddress',
	label: '收货地址',
	width: '150',
	// ischoose: true,
	headerAlign: 'center',
	align: 'center'
}]
